var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgJrc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_2032",
    "data-name": "Group 2032",
    xmlns: "http://www.w3.org/2000/svg",
    width: 439.881,
    height: 46.677,
    viewBox: "0 0 439.881 46.677",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    "data-name": "Group 6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    "data-name": "Group 5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M-651.269,122.531c-6.9,0-11.3-3.416-14.2-8.146l3.753-3.221c2.824,4.27,5.712,6.573,10.513,6.573,5.195,0,9.008-3.749,9.008-11.045V75.859h5.262v30.765c0,10.588-6.12,15.911-14.341,15.907Z",
    transform: "translate(665.464 -75.858)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M-593.7,75.859c6.907,0,11.307,3.42,14.2,8.154l-3.745,3.221c-2.839-4.274-5.719-6.573-10.528-6.573-5.187,0-9.011,3.745-9.011,11.045l0,30.829h-5.259V91.77c0-10.588,6.116-15.911,14.338-15.911Z",
    transform: "translate(823.13 -75.858)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M-608.688,122.531h-5.592l-5.39-12.248h-25.053l-5.457,12.248h-5.326l20.974-46.672h4.869l20.975,46.672Zm-23.469-40.582-10.525,23.638H-621.7l-10.457-23.638Z",
    transform: "translate(692.803 -75.858)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M-634.832,75.859v46.674h-5.195V75.859Z",
    transform: "translate(735.302 -75.859)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M-617.461,106.059h-11.18v16.473h-5.187V75.859H-616.6c10.383,0,17.222,5.6,17.222,14.866,0,10.143-8.285,15.334-18.083,15.334ZM-617,80.724h-11.644v20.536h11.379c7.626,0,12.626-4.135,12.626-10.337,0-6.734-4.94-10.2-12.36-10.2Z",
    transform: "translate(752.317 -75.858)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M-584.281,102.182c0,13.39-7.682,20.349-19.2,20.349-11.375,0-19.128-6.959-19.128-19.952V75.859h5.191v26.39c0,9.91,5.262,15.491,14.072,15.491,8.483,0,13.873-5.12,13.873-15.162V75.859h5.191v26.323Z",
    transform: "translate(783.124 -75.858)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M-578.82,75.859c6.982,0,11.435,3.416,14.364,8.154l-3.787,3.221c-2.873-4.274-5.787-6.577-10.648-6.577-5.247,0-9.113,3.749-9.113,11.049v30.825h-5.311V91.77c0-10.588,6.18-15.911,14.495-15.911Z",
    transform: "translate(863.546 -75.858)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M-564.347,122.531c11.656,0,19.446-6.959,19.446-20.349V75.859h-5.263v26.716c0,10.045-5.461,15.165-14.053,15.165-8.854,0-14.251-5.581-14.251-15.491V75.859h-5.259v26.716c0,13,7.858,19.956,19.379,19.956Z",
    transform: "translate(889.872 -75.858)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M-547.82,122.531a28.123,28.123,0,0,0,18.443-6.9V97.65h-18.967v4.577h13.978v11.214a21.853,21.853,0,0,1-13.255,4.513c-11.158,0-18.18-7.993-18.18-18.757v-.131c0-10.057,7.285-18.5,17.458-18.5a19.718,19.718,0,0,1,13.978,5.161l3.348-3.869c-4.6-3.805-9.386-6-17.132-6-13.78,0-23.035,10.959-23.035,23.338v.127c0,12.892,8.925,23.207,23.364,23.207Z",
    transform: "translate(924.306 -75.858)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M-538.421,122.531c9.15,0,15.731-5.056,15.731-12.836v-.127c0-6.937-4.738-10.63-15.008-12.836C-547.834,94.594-550.2,92.2-550.2,87.916v-.127c0-4.086,3.82-7.326,9.809-7.326a20.434,20.434,0,0,1,13.3,4.925l3.027-3.951a24.265,24.265,0,0,0-16.192-5.577c-8.757,0-15.139,5.251-15.139,12.382v.127c0,7.457,4.869,10.828,15.469,13.1,9.675,2.008,11.978,4.4,11.978,8.618v.131c0,4.472-4.079,7.712-10.266,7.712-6.386,0-10.993-2.139-15.8-6.416l-3.225,3.76a27.183,27.183,0,0,0,18.825,7.259Z",
    transform: "translate(962.572 -75.858)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJrc);
export default __webpack_public_path__ + "static/media/jrc.61181d700d34a55dcc5515e1bc34ea20.svg";
export { ForwardRef as ReactComponent };